import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RolesService } from 'src/app/authentification/roles.service';

export enum ModeRendu {
    SAISIE = 'saisie',
    CONSULTATION = 'consultation',
    IMPRESSION = 'impression'
}
@Injectable({
    providedIn: 'root'
})
export class ModeRenduService {
    private modeRendu = new BehaviorSubject<ModeRendu>(null);

    constructor(
        private rolesService: RolesService
    ) {
        this.modeDefaut();
    }

    /**
     * Permet de mettre le mode par défaut lors de la connexion.
     * Si rôle consultation => uniquement consultation, sinon saisie
     */
    private modeDefaut(): void {
        if (this.rolesService.isHabilite([RolesService.consultation.toLowerCase()])) {
            this.modeRendu.next(ModeRendu.CONSULTATION);
        } else {
            this.modeRendu.next(ModeRendu.SAISIE);
        }
    }

    /**
       * Fonction redirigeant vers la saisie à imprimer.
       * Cette page ouvrira la boîte de dialogue d’impression
       */
    public imprimerSaisie() {
        this.modeRendu.next(ModeRendu.IMPRESSION);
    }

    /**
     * Revenir au mode par defaut
     */
    public revenirModeDefaut() {
        this.modeDefaut();
    }


    /**
     * Fonction pour changer entre le mode de saisie et de consultation.
     * Utile pour tester
     */
    public modeToggle() {
        if (this.modeRendu.value === ModeRendu.SAISIE) {
            this.modeRendu.next(ModeRendu.CONSULTATION);
        } else if (this.modeRendu.value === ModeRendu.CONSULTATION) {
            this.modeRendu.next(ModeRendu.SAISIE);
        }
    }

    /**
     * Passer en modeConsulation
     */
    public modeConsultation() {
        this.modeRendu.next(ModeRendu.CONSULTATION);
    }

    get enModeSaisie$(): Observable<boolean> {
        return this.modeRendu.pipe(map(value => {
            return value === ModeRendu.SAISIE;
        }));
    }
    get enModeConsultation$(): Observable<boolean> {
        return this.modeRendu.pipe(map(value => {
            return value === ModeRendu.CONSULTATION
                || value === ModeRendu.IMPRESSION; // Pas obligatoire cette seconde partie
        }));
    }
    get enModeImpression$(): Observable<boolean> {
        return this.modeRendu.pipe(map(value => {
            return value === ModeRendu.IMPRESSION;
        }));
    }
}
